import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white pb-24 px-6 md:px-12 lg:px-24" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <FadeIn data-id="element-67">
          <div className="border-4 border-gold rounded-2xl p-8 md:p-12 text-center relative bg-cream shadow-lg" data-id="element-68">
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 border-4 border-gold" data-id="element-69">
              <div className="bg-gold rounded-full p-4" data-id="element-70">
                <Shield className="text-white w-10 h-10" data-id="element-71" />
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark-green mt-8 mb-6" data-id="element-72">
              GARANTÍA TOTAL DE 15 DÍAS
            </h2>

            <p className="text-lg md:text-xl text-text-black leading-relaxed mb-6" data-id="element-73">
              Si sigues el protocolo completo durante los 7 días y no notas
              ninguna diferencia, tienes 15 días desde tu compra para solicitar
              tu reembolso completo.
            </p>

            <p className="text-lg md:text-xl text-text-black leading-relaxed mb-6" data-id="element-74">
              Sin formularios. Sin esperas. Solo escríbenos a{' '}
              <span className="font-bold text-dark-green" data-id="element-75">
                soporte@vitalyforms.com
              </span>
            </p>

            <p className="text-xl md:text-2xl font-bold text-dark-green mb-8" data-id="element-76">
              Tienes 15 días para probarlo con cero riesgo.
            </p>

            <p className="text-lg text-text-gray italic mb-8" data-id="element-77">
              Así de seguros estamos de que esto funciona.
            </p>

            <p className="font-serif font-bold text-gold text-xl" data-id="element-78">
              — El Equipo de Investigación de VitalyForms
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}